module.exports = __webpack_public_path__ + "static/media/search_web_1c.7ab560d2.png";